import React, { useEffect } from "react";
import { useStateProvider } from "../common/StateProvider";
import MarkCompletedModal from "./MarkCompletedModal";
import { workflowProfileMeetingData } from "../common/Helper";
import { CopyIcon, StoryBookIcon } from "../common/Icon";
import FollowUpProfilePopUp from "../create-follow-popup/FollowUpProfilePopUp";
import AttachFileModal from "../common/AttachFileModal";

const WorkflowProfileMeeting = () => {
  const { markModal, setmarkModal } = useStateProvider(); //Mark Complete MODAL
  const { markCompleteModalHeading, setmarkCompleteModalHeading } =
    useStateProvider(); //Mark Complete MODEL HEADING
  const { createFollowUpPopUp, setCreateFollowUpPopUp } = useStateProvider(); // CREATE A FOLLOW UP PROFILE MODAL
  // Function to show the Mark Complete MODAL
  const openMarkCompleteModel = (value) => {
    setmarkCompleteModalHeading(value.markCompletedModelHeading);
    setmarkModal(true);
  };
  // Function to show CREATE A  FOLLOW UP PROFILE MODAL
  const openCreateFollowUpModel = () => {
    setCreateFollowUpPopUp(true);
  };

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setCreateFollowUpPopUp(!createFollowUpPopUp);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (createFollowUpPopUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [createFollowUpPopUp]);

  const { profileAttachFileModal, setprofileAttachFileModal } =
    useStateProvider(); //ATTACH FILE MODAL

  // Function to show the Attach File MODAL
  const openMeetingAttachFileModal = () => {
    setprofileAttachFileModal(true);
  };
  return (
    <>
      <div className="px-6 pt-[43px] pb-[60px] h-full flex flex-col relative">
        <div className="flex flex-col flex-grow justify-between">
          <div className=" w-[320px] md:w-auto overflow-x-auto overflow_x_scroll_style">
            {workflowProfileMeetingData.map((value, index) => (
              <div
                className=" w-[600px] sm:w-[600px] md:w-auto p-[16px_20px] rounded-md border border-solid border-[rgba(111,_106,_248,_0.10)] bg-[rgba(111,_106,_248,_0.02)] hover:shadow-workflow_item_card_shadow duration-300  mb-5"
                key={index}>
                <div className=" flex justify-between items-center">
                  <p className="text-[10px] font-medium text-white rounded-[36px] bg-new_bule p-[5px_20px]">
                    {value.upcomingBtn}
                  </p>

                  <div className=" flex items-center gap-2">
                    <button className="rounded-full border-[0.688px] border-solid border-[rgba(0,_0,_0,_0.10)] bg-white p-1 hover:bg-primary hover:border-transparent story-book-icon duration-200">
                      <StoryBookIcon />
                    </button>
                    <button className="rounded-full border-[0.688px] border-solid border-[rgba(0,_0,_0,_0.10)] bg-white p-1 hover:bg-primary hover:border-transparent story-book-icon duration-200">
                      <CopyIcon />
                    </button>
                    <button
                      onClick={() => openMarkCompleteModel(value)}
                      className="text-[10px] 3xl:text-[12px] font-semibold text-gray p-[5px_6px] rounded border-[0.851px] border-solid border-[rgba(0,_0,_0,_0.20)] flex items-center gap-1 hover:bg-primary hover:text-white hover:border-transparent duration-200 markComplete-btn">
                      <span className="markCompleteIcon-icon">
                        {value.markCompleteIcon}
                      </span>
                      {value.markCompleteBtn}
                    </button>
                    <button
                      onClick={openMeetingAttachFileModal}
                      className="text-[10px] font-medium text-primary rounded-[36px] border border-solid border-primary p-[4px_10px] hover:bg-primary hover:text-white hover:border-transparent duration-200">
                      + Attach File
                    </button>
                  </div>
                </div>
                <span className="h-[1px] w-full bg-black opacity-10 block my-3"></span>
                <div className="flex items-center gap-4">
                  <div>
                    <p className="text-[14px] font-normal text-black opacity-70">
                      {value.meetingText}
                    </p>
                    <div className="flex items-center gap-[18px] pt-2">
                      <p className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                        <span className="text-xs 3xl:text-[16px] font-medium text-black opacity-70 pr-2">
                          Date:
                        </span>
                        {value.meetingFullDate}
                      </p>
                      <p className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                        <span className="text-xs 3xl:text-[16px] font-medium text-black opacity-70 pr-2">
                          Time:
                        </span>
                        {value.meetingTime}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-center  py-10 3xl:pb-0">
            <button
              onClick={openCreateFollowUpModel}
              type="submit"
              className="text-[14px] font-medium text-white rounded-[36px] border border-solid border-transparent  outline-none p-[12px_30px] bg-primary flex items-center hover:bg-white hover:text-primary hover:border-primary duration-200">
              Create a Meeting
            </button>
          </div>
        </div>
        {/* Mark Complete MODAL */}
        {markModal && (
          <MarkCompletedModal
            markModal={markModal}
            setmarkModal={setmarkModal}
            markCompleteModalHeading={markCompleteModalHeading}
          />
        )}

        <div className=" fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[8%] z-[9999] 3xl:top-[33%] 3xl:right-[6%]">
          {createFollowUpPopUp && <FollowUpProfilePopUp />}
        </div>
        <div
          onClick={overLayHidden}
          className={`fixed  min-h-full z-[999] top-0 left-0  bg-black opacity-10 ${
            createFollowUpPopUp ? "w-[100%] " : "hidden"
          }`}></div>

        <div className="fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[8%] z-[9999] 3xl:top-[33%] 3xl:right-[6%] ">
          {profileAttachFileModal && (
            <AttachFileModal
              attachFileModal={profileAttachFileModal}
              setAttachFileModal={setprofileAttachFileModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default WorkflowProfileMeeting;
